import { apiCall } from "../../services/api-service";

const getListData = async () => {
  const response = await apiCall("get", "ticket");
  return response?.data?.tickets;
};

export default getListData;

export const getApprovalApi = async (body) => {
  const response = await apiCall("post", "is_approval_available", body);
  return response?.data;
};

export const titleUpdateApi = async (body, id) => {
  const response = await apiCall("put", `ticket/ticket_title/${id}`, body);
  if (response?.status && response.status >= 400) {
    return response;
  }
  return response?.data;
};
export const ticketDetailUpdateApi = async (body, id) => {
  const response = await apiCall("put", `ticket/ticket_details/${id}`, body);
  if (response?.status && response.status >= 400) {
    return response;
  }
  return response?.data;
};
export const othersDetailUpdateApi = async (body, id) => {
  const response = await apiCall("put", `ticket/ticket_others/${id}`, body);
  if (response?.status && response.status >= 400) {
    return response;
  }
  return response?.data;
};
export const descriptionDetailUpdateApi = async (body, id) => {
  const response = await apiCall("put", `ticket/ticket_description/${id}`, body);
  if (response?.status && response.status >= 400) {
    return response;
  }
  return response?.data;
};
export const billingUpdateApi = async (body, id) => {
  const response = await apiCall("put", `ticket/ticket_billing/${id}`, body);
  if (response?.status && response.status >= 400) {
    return response;
  }
  return response?.data;
};

export const getEnabledFieldApi = async () => {
  const response = await apiCall("get", "get_configured_fields");
  return response?.data;
};
